import { render, staticRenderFns } from "./UserLocationListTable.vue?vue&type=template&id=087141d8&"
import script from "./UserLocationListTable.vue?vue&type=script&lang=js&"
export * from "./UserLocationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports